import type { ReactElement } from 'react'

export interface Props {
  isMenuOpen: boolean
  menu: {
    items: {
      label: string
      onClick?: VoidFunction
    }[]
    sectionTitle?: string
  }[]
}

const Menu = ({ isMenuOpen, menu }: Props): ReactElement | null => {
  if (!isMenuOpen) return null

  return (
    <ul className="dropdown-menu-component__menu-container">
      {menu.map(({ items, sectionTitle }, idx) => (
        <div key={idx}>
          {sectionTitle ? <li className="menu-item-title">{sectionTitle}</li> : null}
          {items.map(({ label, onClick }, index) => (
            <li className="menu-item" key={index} onClick={onClick}>
              {label}
            </li>
          ))}
        </div>
      ))}
    </ul>
  )
}

export default Menu
